import { TableBody, TableCell, TableRow } from '@/components/ui';
import { Skeleton } from '@/components/custom';

const DataTableBodySkeleton = ({ rows = 8 }: { rows?: number }) => {
	const keys = Array.from({ length: rows }, () => crypto.randomUUID());

	return (
		<TableBody>
			{keys.map(key => (
				<TableRow key={key} className="h-14">
					<TableCell className="w-[80px] py-2">
						<Skeleton className="h-10 w-10 rounded-md" />
					</TableCell>
					<TableCell className="w-[160px] py-2">
						<div className="flex gap-1">
							<Skeleton className="h-5 w-14 rounded-full" />
							<Skeleton className="h-5 w-14 rounded-full" />
						</div>
					</TableCell>
					<TableCell className="w-[90px] py-2">
						<Skeleton className="h-4 w-12" />
					</TableCell>
					<TableCell className="w-[200px] py-2">
						<Skeleton className="h-4 w-36" />
					</TableCell>
					<TableCell className="w-[110px] py-2">
						<Skeleton className="h-5 w-20 rounded-full" />
					</TableCell>
					<TableCell className="w-[100px] py-2 text-right">
						<div className="flex items-center justify-end gap-1">
							<Skeleton className="h-8 w-8 rounded" />
							<Skeleton className="h-8 w-8 rounded" />
						</div>
					</TableCell>
				</TableRow>
			))}
		</TableBody>
	);
};

export default DataTableBodySkeleton;
